import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/seasonal-campaigns")({
  component: lazyRouteComponent(() => import("./-pages/admin.seasonal-campaigns")),
  head: () => ({
    meta: [
      { title: "Seasonal Broadcasts · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
